import { Stack, Typography } from "@mui/material";
import type { MemberRole } from "../../../../../api/types/userManagementTypes";
import { entriliaProductCaptionMap } from "../../../../../utilities/enumCaptions";
import EntriliaProductIcon from "../../../../common/domain-icons/EntriliaProductIcon";
import type { CompanyProductWithRoles } from "../definitions";
import { roleNamesMap } from "../definitions";

interface ProductDetailsProps {
  product: CompanyProductWithRoles;
  grantedRoles: MemberRole[];
}

const CompanyProductDetails = ({ product, grantedRoles }: ProductDetailsProps) => {
  const roleNames = product.roles.filter((role) => grantedRoles.includes(role)).map((role) => roleNamesMap[role]);

  return (
    <Stack direction="row" spacing={1} sx={{ justifyItems: "center", alignItems: "center" }}>
      <EntriliaProductIcon product={product.key} color="secondary" fontSize="small" />
      <Typography>{entriliaProductCaptionMap[product.key]}</Typography>
      <Typography color="textSecondary">{roleNames.join(", ")}</Typography>
    </Stack>
  );
};

export default CompanyProductDetails;
